import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { type ReactNode } from 'react';
import type React from 'react';

type PageContainerProps = {
  style?: React.CSSProperties;
  children: ReactNode;
};

const PageContainer: React.FC<PageContainerProps> = (props) => (
  <Container maxWidth={false}>
    <Box mt={2} mb={2}>
      <Paper
        style={{
          position: 'relative',
          backgroundColor: '#f4f6f8',
          ...(props.style || {}),
        }}
      >
        <Box p={2}>{props.children}</Box>
      </Paper>
    </Box>
  </Container>
);

export default PageContainer;
